function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*

This module requires a gifphy API key to be set as an environmental variable:
GIPHY_KEY

Modules must provide an input id to attach the gif selector to.

Modules can also provide a callback to determine how the image (url) is processed.

*/
var SaitoOverlay = require('./../../lib/saito/ui/saito-overlay/saito-overlay');
var saitoGifTemplate = require('./lib/giphy.template');
var SaitoLoader = require('./../../lib/saito/ui/saito-loader/saito-loader');
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];
var Giphy = /*#__PURE__*/function (_ModTemplate) {
  function Giphy(app, mod, input_id) {
    var _this;
    var parent_callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, Giphy);
    _this = _callSuper(this, Giphy, [app]);
    _defineProperty(_this, "toDataURL", function (url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      })["catch"](function (err) {
        console.error('Error fetching content: ' + err);
        return '';
      });
    });
    _this.app = app;
    _this.mod = mod;
    _this.name = 'Giphy';
    _this.slug = 'giphy';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.input_id = input_id;
    _this.parent_callback = parent_callback;
    _this.overlay = new SaitoOverlay(app, mod);
    _this.loader = new SaitoLoader(app, mod);
    _this.auth = null;
    _this.gf = null;
    _this.styles = ['/giphy/style.css'];
    return _this;
  }
  _inherits(Giphy, _ModTemplate);
  return _createClass(Giphy, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Giphy, "initialize", this, 3)([app]);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _giphyFetchPkg$defaul;
        var giphyFetchPkg, GiphyFetch, giphy_self, container;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              giphyFetchPkg = require('@giphy/js-fetch-api');
              GiphyFetch = (giphyFetchPkg === null || giphyFetchPkg === void 0 ? void 0 : giphyFetchPkg.GiphyFetch) || (giphyFetchPkg === null || giphyFetchPkg === void 0 || (_giphyFetchPkg$defaul = giphyFetchPkg["default"]) === null || _giphyFetchPkg$defaul === void 0 ? void 0 : _giphyFetchPkg$defaul.GiphyFetch) || (giphyFetchPkg === null || giphyFetchPkg === void 0 ? void 0 : giphyFetchPkg["default"]);
              giphy_self = this; //
              //Calculate reasonable sizing of results
              //
              this.selectorWidth = window.innerWidth;
              if (this.container) {
                container = document.querySelector(this.container);
                if (container) {
                  this.selectorWidth = container.getBoundingClientRect().width;
                }
              }
              this.selectorColumns = 3;
              if (this.selectorWidth > 525) {
                this.selectorWidth = 500 + (this.selectorWidth - 500) / 2;
              }
              if (this.selectorWidth > 750) {
                this.selectorWidth = 750;
              }
              this.selectorColumns = Math.floor(this.selectorWidth / 150);

              //
              // Initiate the Giphy search service
              //
              if (this.auth) {
                _context2.n = 1;
                break;
              }
              console.warn('Giphy auth key not loaded yet');
              return _context2.a(2);
            case 1:
              if (GiphyFetch) {
                _context2.n = 2;
                break;
              }
              console.error('Giphy library import failed: GiphyFetch export not found');
              return _context2.a(2);
            case 2:
              if (!this.gf || this.gf.apiKey === null) {
                this.gf = new GiphyFetch(this.auth);
              }
              if (this.container) {
                if (!document.querySelector('.saito-gif-container')) {
                  this.app.browser.addElementToSelector(saitoGifTemplate(this.app, this.mod), this.container);
                }
              } else {
                this.overlay.show(saitoGifTemplate(this.app, this.mod));
              }

              //this.loader.render(this.app, this.mod, "saito-gif-content");
              this.attachEvents();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'giphy'));
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function onPeerServiceUp(app, peer) {
      var service = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.app.BROWSER == 1) {
        var gif_self = this;
        if (service.service === 'giphy') {
          app.network.sendRequestAsTransaction('get giphy auth', {}, function (res) {
            gif_self.auth = res;
            // If UI is already opened, render once auth arrives.
            if (gif_self.container || document.querySelector('.saito-gif-container')) {
              gif_self.render();
            }
          }, peer.publicKey);
        }
      }
    }
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var giphy_self = this;
      if (type === 'giphy') {
        this.attachStyleSheets();
        return {
          renderInto: function renderInto(container, callback) {
            giphy_self.container = container;
            giphy_self.parent_callback = callback;
            giphy_self.render();
          }
        };
      }
      return _superPropGet(Giphy, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(auth) {
      var _this2 = this;
      var giphy_self = this;
      var gif_search_icon = document.querySelector('.saito-gif-search i');
      var gif_input_search = document.querySelector('.saito-gif-search input');
      var gif_content = document.querySelector('.saito-gif-content');
      if (!gif_content) {
        return;
      }
      var onGifClick = function onGifClick(gif) {
        if (_this2.parent_callback) {
          _this2.parent_callback(gif.images.original.url);
        }
        _this2.overlay.remove();
      };
      var searchGif = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(value) {
          var res, gifs, _t;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                gif_content.classList.remove('results');
                gif_content.innerHTML = '<div class="giphy-loader">Loading...</div>';
                _context3.p = 1;
                _context3.n = 2;
                return _this2.gf.search(value || 'inception', {
                  limit: 24,
                  offset: 0
                });
              case 2:
                res = _context3.v;
                gifs = (res === null || res === void 0 ? void 0 : res.data) || [];
                if (gifs.length) {
                  _context3.n = 3;
                  break;
                }
                gif_content.innerHTML = '<div class="giphy-loader">No GIFs found</div>';
                return _context3.a(2);
              case 3:
                gif_content.innerHTML = '';
                gif_content.classList.add('results');
                gif_content.style.gridTemplateColumns = "repeat(".concat(Math.max(1, giphy_self.selectorColumns), ", minmax(120px, 1fr))");
                gifs.forEach(function (gif) {
                  var _gif$images, _gif$images2, _gif$images3;
                  var img = document.createElement('img');
                  img.src = (gif === null || gif === void 0 || (_gif$images = gif.images) === null || _gif$images === void 0 || (_gif$images = _gif$images.fixed_width_small) === null || _gif$images === void 0 ? void 0 : _gif$images.url) || (gif === null || gif === void 0 || (_gif$images2 = gif.images) === null || _gif$images2 === void 0 || (_gif$images2 = _gif$images2.fixed_width) === null || _gif$images2 === void 0 ? void 0 : _gif$images2.url) || (gif === null || gif === void 0 || (_gif$images3 = gif.images) === null || _gif$images3 === void 0 || (_gif$images3 = _gif$images3.original) === null || _gif$images3 === void 0 ? void 0 : _gif$images3.url);
                  img.alt = (gif === null || gif === void 0 ? void 0 : gif.title) || 'gif';
                  img.loading = 'lazy';
                  img.onclick = function () {
                    return onGifClick(gif);
                  };
                  gif_content.appendChild(img);
                });
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t = _context3.v;
                console.error('Giphy search failed', _t);
                gif_content.innerHTML = '<div class="giphy-loader">Failed to load GIFs</div>';
              case 5:
                return _context3.a(2);
            }
          }, _callee3, null, [[1, 4]]);
        }));
        return function searchGif(_x2) {
          return _ref.apply(this, arguments);
        };
      }();
      if (gif_search_icon) {
        gif_search_icon.onclick = function () {
          var value = (gif_input_search === null || gif_input_search === void 0 ? void 0 : gif_input_search.value) || '';
          searchGif(value);
        };
      }

      //add focus to search bar
      if (gif_input_search) {
        gif_input_search.oninput = function (e) {
          var value = gif_input_search.value;
          console.log(gif_input_search.value, 'giphy search value');
          searchGif(value);
        };
        gif_input_search.onclick = function (e) {
          e.currentTarget.select();
        };
        if (!this.app.browser.isMobileBrowser()) {
          gif_input_search.focus({
            focusVisible: true
          });
        }
      }
      searchGif('inception');
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var tx,
          peer,
          mycallback,
          message,
          api_key,
          _args4 = arguments,
          _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              tx = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              peer = _args4.length > 2 ? _args4[2] : undefined;
              mycallback = _args4.length > 3 ? _args4[3] : undefined;
              if (!(tx == null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, 0);
            case 1:
              message = tx.returnMessage();
              if (!((message === null || message === void 0 ? void 0 : message.request) === 'get giphy auth')) {
                _context4.n = 5;
                break;
              }
              api_key = '';
              _context4.p = 2;
              api_key = process.env.GIPHY_KEY;
              if (!mycallback) {
                _context4.n = 3;
                break;
              }
              mycallback(api_key);
              return _context4.a(2, 1);
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
              console.log('Failed to find key with error: ' + _t2);
            case 5:
              return _context4.a(2, _superPropGet(Giphy, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function handlePeerTransaction(_x3) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }]);
}(ModTemplate);
module.exports = Giphy;